import { Controller } from "@hotwired/stimulus";
import { httpRequest } from "../http";

export default class extends Controller {
  static values = {
    statusUrl: String,
    cancelUrl: String,
  };

  static targets = ["importedRecordsCount", "cancelButton"];

  connect() {
    this._fetchImportStatus();

    this.interval = setInterval(() => {
      this._fetchImportStatus();
    }, 5000);
  }

  disconnect() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  cancelImport() {
    // Disable the button to prevent double-clicks
    if (this.hasCancelButtonTarget) {
      this.cancelButtonTarget.disabled = true;
      this.cancelButtonTarget.classList.add("opacity-50", "cursor-not-allowed");
    }

    // Stop the polling
    if (this.interval) {
      clearInterval(this.interval);
    }

    httpRequest(this.cancelUrlValue, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
    })
      .then((response) => {
        if (response.ok) {
          window.location.reload();
        } else {
          return response.json().then((data) => {
            console.error("Error cancelling import:", data.error);
            window.location.reload();
          });
        }
      })
      .catch((error) => {
        console.error("Error cancelling import:", error);
        window.location.reload();
      });
  }

  _fetchImportStatus() {
    httpRequest(this.statusUrlValue, { method: "GET", cache: "no-store" })
      .then((response) => response.json())
      .then((data) => {
        if (data.import_status !== "in_progress") {
          window.location.reload();
        } else {
          this.importedRecordsCountTarget.textContent =
            data.imported_records_count;
        }
      })
      .catch((error) => {
        console.error("Error fetching import status:", error);
        window.location.reload();
      });
  }
}
